import { getCircular } from '@/api/lottery';
export default {
  name: 'circularLotter',
  data() {
    return {
      rotate: 0,
      rotateStatus: false,
      duringTime: 6,
      //旋转的时间
      number: 8 //旋转的圈数
    };
  },
  methods: {
    async rotateCirculat() {
      if (this.rotateStatus) return;
      this.rotateStatus = true;

      //获取是否中奖和旋转角度
      const {
        data
      } = await getCircular();
      this.rotate = 360 * this.number + data.angle;
      setTimeout(() => {
        this.rotateStatus = false;
        this.rotate = this.rotate % 360;
        alert(data.message);
      }, this.duringTime * 1000 + 200);
    }
  }
};